import axios from '@/api/axios'

const register = (credentials) => {
  return axios.post('/users', {user: credentials})
}

const loginUser = (credentials) => {
  return axios.post('/auth/login/user', credentials)
}

const loginTrainer = (credentials) => {
  return axios.post('/auth/login/trainer', credentials)
}

const loginAdmin = (credentials) => {
  return axios.post('/auth/login/admin', credentials)
}

const login = async (type, credentials) => {
  if (type === 'admin') {
    return await loginAdmin(credentials)
  }
  if (type === 'user') {
    return await loginUser(credentials)
  }
  if (type === 'trainer') {
    return await loginTrainer(credentials)
  }

  if (type === 'admin') {
    return await loginAdmin(credentials)
  }

  throw Error('error user type')
}

const getCurrentUser = () => {
  return axios.get('/user')
}

const updateCurrentUser = (currentUserInput) => {
  return axios
    .put('/user', {user: currentUserInput})
    .then((response) => response.data.user)
}

const resetPassword = (password) => {
  return axios.post(`/auth/reset/password`, password)
}

export default {
  register,
  login,
  getCurrentUser,
  updateCurrentUser,
  resetPassword,
}
